import React from "react";
import noRight from "../assets/unauthorised.png";

const UnAuthorized = ({ message }) => {
  return (
    <div style={{ width: "30%", margin: "auto", marginTop: "30px" }}>
      <div className='text-center'>
        <img src={noRight} alt='No Right' width={100} />
      </div>
      <div className='text-center'>
        <h6>
          {message
            ? message
            : "You do not have sufficient permissions to view this page"}
        </h6>
      </div>
    </div>
  );
};

export default UnAuthorized;
